import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../public/fonts/GFSDidot-Regular.woff2%22,%22variable%22:%22--font-gfs-didot%22,%22display%22:%22swap%22,%22weight%22:%22400%22,%22fallback%22:[%22Georgia%22,%22serif%22]}],%22variableName%22:%22gfsDidot%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'gfsDidot', 'gfsDidot Fallback', Georgia, serif",
        fontWeight: 400,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
